// TODO: delete replace and map after it's ready on backend
export const replaceUrl = (url: string) => {
  if (url?.startsWith('/app')) {
    return url.replace('/app', import.meta.env.REACT_APP_BOBE_API as string);
  }
  return url;
};
